import React from 'react';
import { useNavigate } from 'react-router-dom';
import EntityManagementScreen from '../common/EntityManagementScreen';
import { PATIENT_FIELDS_TO_HIDE } from '../../constants/patientFormFields';

// Patient list only — Create and View/Edit are dedicated pages (see PatientDetailScreen)
// under /patients/create and /patients/:patientId, so the uploaded-files panel never mounts
// on a fresh create.
const PatientManagementScreen = () => {
  const navigate = useNavigate();

  return (
    <EntityManagementScreen
      entityName="Patient"
      beautifulName="Patient"
      fieldsToHide={PATIENT_FIELDS_TO_HIDE}
      onCreateClick={() => navigate('/patients/create')}
      onEditClick={(patientId) => navigate(`/patients/${patientId}`)}
    />
  );
};

export default PatientManagementScreen;
